/** Chiavi virtuali Fidodb → tabella fisica usata per join-compatibility in UI. */
export const FIDO_VIRTUAL_FIELD_SOURCE_TABLE: Readonly<Record<string, string>> = {
  'fidodb.nuovi_iscritti': 'utente',
  'fidodb.clienti_attivati': 'payment',
  'fidodb.clienti_paganti_periodo': 'utente',
  'fidodb.cambio_commercialista': 'utente',
  'fidodb.aperture_partita_iva': 'utente',
  'fidodb.mese_iscrizione': 'utente',
  'fidodb.mese_pagamento': 'payment',
  'fidodb.mese_attivazione': 'abbonamento',
  'fidodb.eta_cliente': 'anagrafica',
  'fidodb.id_utente': 'anagrafica',
  'fidodb.codice_ateco': 'com_dettagli_cliente',
  'fidodb.descrizione_ateco': 'com_dettagli_cliente',
  'fidodb.provincia_cliente': 'place',
  'fidodb.regione_cliente': 'place',
  'fidodb.citta_cliente': 'place',
};

/** Split Fidodb sempre esposti in Custom Report quando il profilo è attivo. */
export const FIDO_GEO_SPLIT_CATALOG: ReadonlyArray<{
  key: string;
  label: string;
}> = [
  {
    key: 'fidodb.id_utente',
    label: 'ID utente',
  },
  {
    key: 'fidodb.provincia_cliente',
    label: 'Provincia cliente (sede legale)',
  },
  {
    key: 'fidodb.regione_cliente',
    label: 'Regione cliente (sede legale)',
  },
  {
    key: 'fidodb.citta_cliente',
    label: 'Città cliente (sede legale)',
  },
  {
    key: 'fidodb.eta_cliente',
    label: 'Età cliente (fascia)',
  },
  {
    key: 'fidodb.codice_ateco',
    label: 'Codice ATECO',
  },
  {
    key: 'fidodb.descrizione_ateco',
    label: 'Descrizione ATECO',
  },
];

export function isFidodbVirtualFieldKey(fieldKey: string): boolean {
  return String(fieldKey || '')
    .toLowerCase()
    .startsWith('fidodb.');
}

export function resolveFidodbVirtualSourceTable(fieldKey: string): string | null {
  const key = String(fieldKey || '').toLowerCase();
  return FIDO_VIRTUAL_FIELD_SOURCE_TABLE[key] || null;
}
